import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Bot, Inbox, Mic, Sparkles } from "lucide-react";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

const modules = [
  {
    title: "Reply Agent",
    icon: Bot,
    body: "AI drafts on-brand replies for X (Twitter), LinkedIn, and Reddit — queued for human approval.",
    to: "/reply-agent",
  },
  {
    title: "Lead Inbox",
    icon: Inbox,
    body: "One scored, filtered inbox for every qualifying X (Twitter), LinkedIn, and Reddit conversation — filterable by source.",
    to: "/lead-inbox",
  },
  {
    title: "Brand Voice",
    icon: Mic,
    body: "Trained on your site and past replies, so every draft sounds like you.",
    to: "/brand-voice-feature",
  },
  {
    title: "Pipeline Analytics",
    icon: Sparkles,
    body: "From reply sent to demo booked — every step attributable.",
    to: "/case-studies",
  },
];

export default function Product() {
  return (
    <MarketingPage
      seo={{
        title: "Product — AI lead discovery & reply for X, LinkedIn & Reddit",
        description:
          "Collavue is the end-to-end product for B2B teams who want to find people asking for what they offer on X, LinkedIn, and Reddit and reply on autopilot — with a human in the loop.",
        path: "/product",
        keywords:
          "Collavue product, AI lead generation product, X social listening, Twitter social listening, LinkedIn social listening, LinkedIn lead generation, Reddit social listening, Reddit lead generation, B2B social outreach product",
      }}
    >
      <PageHero
        eyebrow="Product"
        title="One product. Four modules."
        italicWord="Zero busywork."
        description="Every Collavue module is built around the same loop — find, score, draft, approve, send."
      />

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-5">
          {modules.map((m) => (
            <Link
              key={m.title}
              to={m.to}
              className="group rounded-2xl border border-[#e3dccb] p-7 bg-[#faf6ee]/40 hover:border-[#2d5bff] transition-colors"
            >
              <div className="flex items-center justify-between">
                <m.icon className="w-7 h-7 text-[#2d5bff]" />
                <ArrowUpRight className="w-5 h-5 text-[#0a1736] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </div>
              <h3 className="font-display text-2xl text-[#0a1736] font-semibold mt-4">{m.title}</h3>
              <p className="text-[#5a6478] mt-2 leading-relaxed">{m.body}</p>
            </Link>
          ))}
        </div>
      </section>
    </MarketingPage>
  );
}
